import ImageWithFallback from 'components/ImageWithFallback';

import { getMediaTypeIcon } from './helpers';

/**
 * Paylaşımlı medya küçük-resim kutusu. Görsel URL'i verilirse onu (cover ile) gösterir;
 * yoksa veya görsel kırıksa medya türüne göre ikon fallback'ine düşer. Hem tablo "Medya"
 * hücresi (`ArticleOrderMedia`) hem yüklenen dosya grid kartları (`UploadArea`) bu kutuyu
 * kullanır; aksi halde aynı küçük-resim iki yerde farklı stille çizilirdi.
 *
 * @param {Object} props
 * @param {string} [props.src] - Küçük resim URL'i; verilmezse tür ikonu gösterilir (default: yok)
 * @param {string} [props.mediaType] - 'photo' | 'video' | 'audio'; fallback ikonunu belirler (default: dosya-görsel ikonu)
 * @param {number} [props.size=36] - Kutunun kenar uzunluğu, px. `fill` true iken yok sayılır.
 * @param {boolean} [props.fill=false] - true ise kutu, kapsayıcısını tamamen doldurur (responsive kare grid kartı için);
 *   `size` yerine %100 genişlik/yükseklik alır, fallback ikonu büyük (32px) render edilir.
 * @param {string} [props.alt=''] - Görsel alt metni
 * @param {boolean} [props.bordered=false] - true ise kenarlık + gri arka plan çerçevesi çizilir (tablo hücresi için)
 */
function MediaThumb({ src, mediaType, size = 36, fill = false, alt = '', bordered = false }) {
  const TypeIcon = getMediaTypeIcon(mediaType);

  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-center"
      style={{
        width: fill ? '100%' : size,
        height: fill ? '100%' : size,
        borderRadius: bordered ? 8 : 4,
        overflow: 'hidden',
        flexShrink: 0,
        ...(bordered && { border: '1px solid #f0f0f0', background: '#fafafa' }),
      }}
    >
      <ImageWithFallback
        src={src || undefined}
        alt={alt}
        fallback={<TypeIcon style={{ fontSize: fill ? 32 : Math.round(size / 2), color: '#8c8c8c' }} />}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </div>
  );
}

export default MediaThumb;
